// 存储
export default [
  // 接口请求统一 header
  {
    name: 'CACHE_LOGIN_MODEL',
    value: 'cache_login_model'
  },
]